import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState
} from 'react'

import { fetchHomePayload } from '../api/changelogApi'
import type { ChangelogEntry } from '../types'

type ChangelogContextValue = {
  banner: ChangelogEntry | null
  modal: ChangelogEntry | null
  unreadCount: number
  setBanner: (entry: ChangelogEntry | null) => void
  setModal: (entry: ChangelogEntry | null) => void
  setUnreadCount: (count: number) => void
  refresh: () => Promise<void>
}

const ChangelogContext = createContext<ChangelogContextValue | null>(null)

export function ChangelogProvider({ children }: { children: ReactNode }) {
  const [banner, setBanner] = useState<ChangelogEntry | null>(null)
  const [modal, setModal] = useState<ChangelogEntry | null>(null)
  const [unreadCount, setUnreadCount] = useState(0)

  const refresh = useCallback(async () => {
    const payload = await fetchHomePayload()
    setBanner(payload.banner)
    setModal(payload.modal)
    setUnreadCount(payload.unread_count)
  }, [])

  return (
    <ChangelogContext.Provider
      value={{
        banner,
        modal,
        unreadCount,
        setBanner,
        setModal,
        setUnreadCount,
        refresh
      }}
    >
      {children}
    </ChangelogContext.Provider>
  )
}

export function useChangelog() {
  const ctx = useContext(ChangelogContext)
  if (!ctx)
    throw new Error('useChangelog deve ser usado dentro de ChangelogProvider')
  return ctx
}
